import client from '../base-api';

const serviceURL = '/client';
const subClientServiceURL = '/sub-client';

const clientService = {

    getClientNextNumber() {
        return client.get(`${serviceURL}/next-number`);
    },
    getClients(filterData: any) {
        return client.get(`${serviceURL}`, {params: filterData});
    },
    getClient(clientId: number) {
        return client.get(`${serviceURL}/${clientId}`);
    },
    postClient(clientData: any) {
        return client.post(`${serviceURL}`, clientData);
    },
    putClient(clientData: any, clientId: number) {
        return client.put(`${serviceURL}/${clientId}`, clientData);
    },
    deleteClient(clientId: number) {
        return client.delete(`${serviceURL}/${clientId}`);
    },


    // Sub client
    getSubClients(filterData: any) {
        return client.get(`${subClientServiceURL}`, {params: filterData});
    },
    getSubClient(clientId: number) {
        return client.get(`${subClientServiceURL}/${clientId}`);
    },
    postSubClient(clientData: any) {
        return client.post(`${subClientServiceURL}`, clientData);
    },
    putSubClient(clientData: any, clientId: number) {
        return client.put(`${subClientServiceURL}/${clientId}`, clientData);
    },
    deleteSubClient(clientId: number) {
        return client.delete(`${subClientServiceURL}/${clientId}`);
    },
}

export default clientService;